export enum LandingPageType {
  HOME = "home",
  VENDORS = "vendors",
  MANAGEMENT_COMPANIES = "management-companies",
}
